module.exports = __webpack_public_path__ + "img/05.964cfb05.png";